<template>
  <!-- <empty
    v-if="editReviews.length===0"
    :can-edit="canEdit"
    @create-review="createReview"
  /> -->
  <a-collapse
    v-model:activeKey="activeKey"
    expand-icon-position="right"
    :bordered="false"
    class="review"
  >
    <a-collapse-panel
      v-for="q in quarters"
      :key="q"
    >
      <div
        v-if="'id' in reviews.get(q) && reviews.get(q).reviewContent"
        :class="{result: true, pointer: canEdit}"
        @click="editHandler(q)"
      >
        <div v-html="reviews.get(q).reviewContent" />
        <FileList
          :can-edit="false"
          :files="JSON.parse(reviews.get(q).reviewAttachments || '[]')"
          :style="{ marginTop: '8px' }"
        />
      </div>
      <div v-else-if="canEdit">
        <CreateButton
          :text="$t('okr.review.inputReview')"
          icon-name="iconbianji"
          :style="{ backgroundColor: '#F8F9FF' }"
          @click="editHandler(q)"
        />
      </div>
      <div
        v-else
        class="result"
      >
        <span>{{ $t(`okr.nothing`) }}</span>
      </div>
      <template #header>
        <a-space :style="{ marginLeft: '24px' }">
          <IconFont
            type="iconfupanzongjie"
            :style="{ fontSize: '18px' }"
          />
          <span :style="{ fontWeight: 'bold' }">
            {{ `${q} ${$t(`okr.titles.subTitle`)}` }}
          </span>
        </a-space>
      </template>
    </a-collapse-panel>
  </a-collapse>
  <edit
    v-model:visible="visible"
    :related-id="relatedId"
    :review="review"
    v-bind="$attrs"
  />
</template>

<script>
import { computed, ref, toRefs } from 'vue'

import FileList from '@/components/FileList'
import Edit from './edit.vue'
// import Empty from './empty.vue'
import CreateButton from '@/components/CreateButton'
import { useStore } from 'vuex'

export default {
  components: {
    Edit,
    CreateButton,
    // Empty,
    FileList
  },
  props: {
    relatedId: {
      type: Number,
      required: true
    },
    editReviews: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    }
  },
  setup (props) {
    const store = useStore()
    const upload = ref(null)
    const { canEdit } = toRefs(props)
    const visible = ref(false)
    const editQuarter = ref(undefined)
    function editHandler (q) {
      if (!canEdit.value) {
        return
      }
      editQuarter.value = q
      visible.value = true
    }

    const { editReviews } = toRefs(props)
    const displayYear = computed(() => {
      return Number((store.state.yearCycles[store.state.activeYearIndex])[0].displayName)
    })

    // get quarter
    const quarters = (() => {
      const arr = ['Q1', 'Q2', 'Q3', 'Q4']
      const currentYear = new Date().getFullYear()
      const month = new Date().getMonth()
      if (currentYear === displayYear.value) {
        arr.splice(Math.floor(month / 3))
      }
      return arr
    })()
    // end

    const reviews = computed(() => {
      const map = new Map()
      editReviews.value.forEach(item => {
        map.set(item.reviewFlag, item)
      })
      quarters.forEach(q => {
        if (!map.has(q)) {
          map.set(q, {
            reviewFlag: q
          })
        }
      })
      return map
    })
    const review = computed(() => reviews.value.get(editQuarter.value))
    const activeKey = ref(quarters)

    const createReview = () => {
      editHandler(quarters[quarters.length - 1])
    }

    return {
      upload,
      activeKey,
      visible,
      editHandler,
      quarters,
      reviews,
      review,
      createReview
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-collapse-content) > .ant-collapse-content-box {
  padding: 4px 44px 16px;
}

.review-title {
  font-weight: bold;

  &:not(:first-child) {
    margin-top: 1em;
  }
}

:deep(.ant-collapse-header) {
  display: flex;
  align-items: center;
  border-top: 1px solid #f0f0f0;

  .ant-collapse-arrow {
    margin-left: 8px;
    position: static !important;
    order: 2;
    transform: none !important;
  }
}

:deep(.ant-collapse-content-box) {
  padding: 4px 8px 16px 8px !important;
}

.result {
  padding: 0 44px;
}

.pointer {
  cursor: pointer;
}

.review {
  background: #fff;
  box-shadow: 0 0 6px 0 rgb(39 52 125 / 8%);
  border-radius: 8px;
}
</style>
